// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1Ctf0","actions":"GroupTable_actions__1yCgo","deleteModalFooter":"GroupTable_deleteModalFooter__3sxFi"};